export const commonTextLabelStyle = {
  "& .MuiInputLabel-root ": {
    fontSize: "17px",
    "&.Mui-focused": {
      color: "#000",
      backgroundColor: "#FFF",
      fontWeight: 300,
    },
    color: "#000",
    backgroundColor: "",
    fontWeight: 300,
  },
  "& .MuiFormControlLabel-label ": {
    fontSize: "17px",
    color: "#000",
    backgroundColor: "#FFF",
    fontWeight: 300,
  },
};

export const commonTextLabelRoleStyle = {
  "&.MuiOutlinedInput-root .MuiInputBase-input": {
    paddingLeft: "0px !important",
    paddingRight: "0.75rem !important",
    marginTop: "5px !important",
    height: "35px !important",
    overflow: "hidden",
    textOverflow: "ellipsis",
  },
  "&.MuiFormControl-root div": {
    height: "35px !important",
  },
  backgroundColor: "#fff",
  width: "200px !important",
};

export const quickSearchStyle = {
  "& .MuiOutlinedInput-root ": {
    backgroundColor: "#D9D9D9",
  },
};
export const commonComboboxLabelStyle = {
  backgroundColor: "#FFF",
  "&.MuiInputLabel-root": {
    fontSize: "19px",
    color: "#000000 !important",
    "&.Mui-focused": {
      color: "#000",
      backgroundColor: "#FFF",
      fontWeight: 300,
    },
  },
};
